<template>
  <div class="consult-entry-wrap">
    <!-- <img class="kefu" src="../../../assets/images/kefu.png" alt="" />
      -->
    <div class="settle-entry" @click="handleSettle">
      <img src="../../../assets/images/org-settle.png" alt="" />
      <p>机构入驻</p>
    </div>
    <ul class="list-wrap">
      <li class="item wx-code">
        <img class="item-icon" src="../../../assets/images/wechat.png" alt="" />
        <p class="item-title">微信咨询</p>
        <!-- 微信二维码 -->
        <div class="wx-qrcode-wrap">
          <div>
            <p class="title">即刻入驻 和CEO聊聊</p>
            <img
              class="qrcode"
              :src="
                consultQrcodeUrl + '?t=' +
                time
              "
              alt=""
            />
            <p class="tips">扫码添加微信</p>
          </div>
        </div>
      </li>
      <li class="item appoint-item">
        <img
          class="item-icon"
          src="../../../assets/images/phone-1.png"
          alt=""
        />
        <p class="item-title">电话咨询</p>
        <!-- 预约电话 -->
        <div class="appoint-phone" v-show="showAppoint">
          <div>
            <template v-if="!haveAppoint">
              <p class="title">预约电话</p>
              <p class="tips">专家顾问将在24小时内向您致电</p>
              <div class="input-wrap" :class="{ error: error }">
                <el-input
                  v-model.trim="phoneNumber"
                  class="phone-input"
                  placeholder="请填写您的手机号"
                  maxlength="11"
                  @input="handelInput"
                >
                </el-input>
                <span class="error-tips">请输入正确的手机号</span>
              </div>
              <button
                @click="submitPhone"
                v-preventReClick
                class="reservation-btn submit-btn"
              >
                立即预约
              </button>
            </template>
            <template v-else>
              <div class="success-title">
                <img
                  class="success-icon"
                  src="../../../assets/images/dui-icon.png"
                  alt=""
                />
                <p class="success-text">预约成功</p>
              </div>

              <p class="tips text-center">专家顾问将在24小时内向您致电</p>
              <img
                class="qrcode"
                :src="
                  'https://cdn.moguocdn.com/cdn/static/images/kehu_zixun_qrcode.png?t=' +
                  time
                "
                alt=""
              />
              <p class="success-scan-tips">扫码添加微信</p>
              <!-- <button
                @click="handleCloseAppoint"
                class="reservation-btn submit-btn"
              >
                我知道了
              </button> -->
            </template>
            <div class="phone-wrap">
              <img class="icon" src="../../../assets/images/phone.png" alt="" />
              <div class="info-wrap">
                <p class="time">咨询电话 10:00-21:00</p>
                <p class="phone">400-628-2024</p>
              </div>
            </div>
          </div>
        </div>
      </li>
      <div class="divider"></div>
      <li class="item gift-item">
        <img class="item-icon" src="../../../assets/images/gift.png" alt="" />
        <p class="item-title">限时礼包</p>
        <!-- 预约电话 -->
        <div class="gift-phone">
          <div
            class="gift-item-wrap"
            v-for="(item, index) in giftItem"
            :key="index"
          >
            <div class="gift-item-title">
              {{ item.title }}
            </div>
            <div class="gift-item-description">
              {{ item.instructions }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  vailPhone,
  getHourTimestamp,
} from "@saas/components/src/utils/utils.js";
import {
  consultationApplication,
  fastCreateOrganization,
} from "@saas/service-api/src/organization";
import { getEquity } from "@saas/service-api/src/settle-in";
import { getMoguoCdnUrl } from "../../utils/assets";
export default {
  data: function () {
    return {
      showQrcode: false,
      phoneNumber: "",
      haveAppoint: false,
      error: false,
      loading: false,
      showAppoint: true,
      showGift: false,
      time: 0,
      giftItem: [],
    };
  },

  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    isSettle() {
      return this.user && this.user.org_id;
    },
    consultQrcodeUrl() {
      return getMoguoCdnUrl("/cdn/static/images/kehu_zixun_qrcode.png");
    },
  },
  methods: {
    handleCloseAppoint() {
      this.showAppoint = false;
      setTimeout(() => {
        this.showAppoint = true;
      }, 200);
    },
    handelInput() {
      if (this.error) {
        if (!vailPhone(this.phoneNumber)) {
          this.error = false;
        }
      }
    },
    submitPhone() {
      if (!vailPhone(this.phoneNumber)) {
        this.error = true;
        return false;
      }
      // 提交
      if (this.loading) return;
      this.loading = true;
      consultationApplication({
        mobile: this.phoneNumber,
      })
        .then((res) => {
          if (res.code === 1) {
            this.haveAppoint = true;
          } else {
            this.$showToast(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSettle() {
      // 如果用户已经登录，有没有机构都需要跳转到管理后台
      if (this.isAuthenticated) {
        if (this.isSettle) {
          window.open(process.env.VUE_APP_ADMIN_URL, "_blank");
        } else {
          // 么有机构,创建机构
          fastCreateOrganization()
            .then((res) => {
              if (res.code === 1) {
                window.open(process.env.VUE_APP_ADMIN_URL, "_blank");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.$message.error("机构创建失败，请稍后重试");
            });
        }
      } else {
        // 打开登录页
        this.$loginDialog({
          isShowEquity: true,
        });
      }
    },
    getEquity() {
      getEquity().then((res) => {
        if (res.code === 1) {
          this.giftItem = res.data?.equity_list || [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {
    this.time = getHourTimestamp();
    this.getEquity();
  },
};
</script>

<style lang="scss" scoped>
.consult-entry-wrap {
  z-index: 9;
  position: fixed;
  right: 28px;
  // bottom: 100px;
  width: 50px;
  top: 50%;
  transform: translateY(-50%);

  // height: 114px;
  .kefu {
    position: absolute;
    top: -36px;
    left: 50%;
    transform: translateX(-50%);
    width: 42px;
    height: 42px;
  }
  .settle-entry {
    width: 50px;
    height: 56px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.06);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e5e6eb;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
    p {
      margin-top: 2px;
      font-weight: 600;
      font-size: 10px;
      background: linear-gradient(135deg, #00eb81 0%, #00c89d 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      line-height: 14px;
    }
  }

  .list-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.06);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e5e6eb;
    padding: 10px 0;
  }
  .divider {
    width: 34px;
    height: 1px;
    background: #e5e6eb;
    margin: 9px auto;
  }
  .item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    border-bottom: 1px solid rgba($color: #fff, $alpha: 0.1);
    &:last-child {
      border-bottom: none;
    }
    .item-icon {
      width: 20px;
      height: 20px;
      margin-bottom: 2px;
    }
    .item-title {
      font-weight: 500;
      font-size: 10px;
      color: #323232;
      line-height: 14px;
      margin-top: 2px;
    }
  }
  .input-wrap {
    position: relative;
    &.error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c !important;
      }
      .error-tips {
        display: block;
      }
    }
    .error-tips {
      display: none;
      position: absolute;
      bottom: 0;
      left: 5px;
      color: #f56c6c;
      font-size: 12px;
      line-height: 24px;
    }
  }
  .wx-code {
    position: relative;
    box-sizing: content-box;
    &:hover {
      .wx-qrcode-wrap {
        opacity: 1;
        pointer-events: auto;
        & > div {
          padding-right: 36px;
          margin-right: -36px;
        }
      }
    }
  }
  .appoint-item {
    position: relative;
    box-sizing: content-box;
    margin-top: 14px;
    &:hover {
      .appoint-phone {
        opacity: 1;
        pointer-events: auto;
        & > div {
          padding-right: 60px;
          margin-right: -36px;
        }
      }
    }
  }
  //   微信二维码
  .wx-qrcode-wrap {
    pointer-events: none;
    opacity: 0;
    transition: all 0.5s;
    position: absolute;
    bottom: -57px;
    right: 86px;
    width: 339px;
    height: 378px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
    background-image: url("../../../assets/images/consult-entry/dialog-bg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    & > div {
      height: 100%;
      padding-top: 29px;
    }
    .title {
      text-align: center;
      font-weight: 500;
      font-size: 26px;
      color: #000000;
      line-height: 37px;
      margin-bottom: 22px;
    }
    .qrcode {
      width: 215px;
      height: 215px;
      margin: 0 auto 20px;
    }
    .tips {
      padding-left: 18px;
      text-align: center;
      font-weight: 500;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      letter-spacing: 20px;
    }
  }
  //   预约电话
  .appoint-phone {
    pointer-events: none;
    opacity: 0;
    transition: all 0.5s;
    width: 339px;
    height: 378px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
    background-image: url("../../../assets/images/consult-entry/dialog-bg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: absolute;
    bottom: 0;
    right: 86px;
    & > div {
      height: 100%;
      padding: 24px 24px 0;
    }
    .title {
      font-weight: 500;
      font-size: 26px;
      color: #000000;
      line-height: 37px;
      margin-bottom: 6px;
    }
    .tips {
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 28px;
      margin-bottom: 27px;
    }
    .text-center {
      margin-bottom: 14px;
    }
    ::v-deep .phone-input {
      margin-bottom: 24px;
      .el-input__inner {
        border-radius: 12px;
        border: 1px solid #e5e6eb;
        height: 56px;
        line-height: 56px;
        font-size: 20px;
        color: #0d1400;
      }
      .el-input__inner::placeholder {
        font-size: 20px;
        color: #858687;
        text-align: center;
      }
    }
    .success-title {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 20px;
        height: 20px;
        margin: 0;
        margin-right: 4px;
      }
      p {
        font-weight: 500;
        font-size: 20px;
        color: #000000;
        margin: 0;
      }
    }
    .success-icon {
      width: 56px;
      height: 56px;
      margin-top: 5px;
      margin: 0 auto 18px;
    }
    .success-text {
      font-weight: 500;
      font-size: 26px;
      color: #000000;
      line-height: 37px;
      margin-bottom: 6px;
      text-align: center;
    }
    .phone-wrap {
      padding-top: 15px;
      border-top: 1px solid #efefef;
      display: flex;
      align-items: center;
      .icon {
        width: 50px;
        height: 50px;
        margin-right: 12px;
      }
      .time {
        font-size: 18px;
        color: #575859;
        line-height: 25px;
      }
      .phone {
        font-size: 26px;
        color: #0d1400;
        line-height: 37px;
        font-weight: 600;
      }
    }
    .qrcode {
      width: 160px;
      height: 160px;
      margin: 0 auto;
    }
    .success-scan-tips {
      height: 20px;
      font-weight: 500;
      font-size: 14px;
      color: #0d1400;
      letter-spacing: 12px;
      text-align: center;
      margin-bottom: 10px;
      padding-left: 10px;
    }
  }
  .submit-btn {
    width: 291px;
    height: 56px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 12px;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
    margin-bottom: 20px;
  }
  .gift-item {
    position: relative;
    box-sizing: content-box;

    &:hover {
      .gift-phone {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
  .gift-phone {
    pointer-events: none;
    opacity: 0;
    transition: all 0.5s;
    position: absolute;
    bottom: -57px;
    right: 86px;
    width: 175px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.06);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e5e6eb;
    padding: 12px;
    .gift-item-wrap {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .gift-item-title {
        font-weight: 500;
        font-size: 12px;
        color: #323232;
        height: 17px;
        line-height: 17px;
      }
      .gift-item-description {
        margin-top: 4px;
        font-weight: 400;
        font-size: 10px;
        color: #575859;
        line-height: 14px;
      }
    }
  }
}
</style>
